<form #blockInputs="ngForm">
  <glxy-form-field class="review-request-links">
    <ng-container *ngFor="let source of reviewSources">
      <mat-checkbox
        color="primary"
        [checked]="isSourceSelected(source.sourceId)"
        (change)="valueChange(source.sourceId, $event)"
      >
        {{ source.name | translate }}
      </mat-checkbox>
    </ng-container>
  </glxy-form-field>
</form>
